import { useParams } from "react-router-dom";
import { CircularProgress } from '@mui/material';
import useFetch from "../useFetch";
import { useState } from "react";

const FilipinoBksRead = () => {
    const {id} = useParams();
    const regex = /\*\*/g;
    const [nightMode,setNightmode] = useState(false);
    
    const {data: books, ispending,erroralert} = useFetch(`${process.env.REACT_APP_BOOKS_SERVER_URL}/FilipinoBooks/`+ id);


    return ( 
        <div className={`blog-details ${nightMode? 'nightmode':'normal'}`}>
        {erroralert && <div> {erroralert}</div>}
      {ispending && <div style={{marginTop: "2rem"}}> 
      <CircularProgress color="secondary"/> <br/>
      Preparing Book...
      </div>} 

      {!ispending && !nightMode && <button id="toggleButton" onClick={() => {setNightmode(!nightMode)}} >pagbabasa sa gabi</button>}
  {nightMode && <button id="toggleButton" onClick={() => {setNightmode(!nightMode)}} style={{
      backgroundColor: "#ddd",
      color: "black"
  }}>lumipat sa normal</button>}
    
      {books && (
          <article>
            <h2>{books.title}</h2>
            <h3>sinulat ni {books.author}</h3>
            <img src={books.image} alt="book cover"></img>
            <p>{books.body.replace(regex,"\n\n")}</p>
      
          </article>
      )}
  </div>
     );
}
 
export default FilipinoBksRead;